import styled from "styled-components"

const TaskPopoverContent = styled.div`
    padding: 0 12px 12px 12px;
`

export default TaskPopoverContent